if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            // subscription switch events
              const sellingOptions = document.getElementsByName("selling_options");
              const sellingPlansEl = document.querySelector("select[name='selling_plan']")
              const product_form = document.querySelector('product-info product-form form');

              for (let i = 0; i < sellingOptions.length; i++) {
                sellingOptions[i].addEventListener('change', function() {
                  var parentWidget = this.closest('[data-js-widget]');

                  document.querySelectorAll('[data-js-widget]').forEach(function(widget) {
                      widget.classList.remove('active');
                  });
                  if (this.checked) {
                    parentWidget.classList.add('active');
                  }

                  if(product_form) {
                    parentWidget.querySelector('select[data-qty-select]').value = 1;
                    parentWidget.querySelector('select[data-qty-select]').dispatchEvent(new Event('change', { bubbles: true }));

                    parentWidget.querySelector('.origin[data-var-index="0"] select').selectedIndex = 0;
                    parentWidget.querySelector('.origin[data-var-index="0"] select').dispatchEvent(new Event('change', { bubbles: true }));

                    product_form.querySelector('.js-inputs-ids').innerHTML = '';
                  }

                  if(parentWidget.hasAttribute('data-option-subsave')) {
                    product_form.querySelector('.js-inputs-ids').innerHTML = `
                    <input type="hidden" name="[items][0][id]" value="${parentWidget.parentElement.getAttribute('data-default-variant')}">
                    <input type="hidden" name="[items][0][selling_plan]" class="sellingPlan" value="${sellingPlansEl.value}">`
                    // parentWidget.closest('product-info').querySelector("input[name='selling_plan']").value = sellingPlansEl.value
                  } else {
                    product_form.querySelector('.js-inputs-ids').innerHTML =  
                    `<input type="hidden" name="[items][0][id]" value="${parentWidget.parentElement.getAttribute('data-default-variant')}">`
                    // parentWidget.closest('product-info').querySelector("input[name='selling_plan']").value = ''
                  }
                });
              }

              if(sellingPlansEl) {
                sellingPlansEl.addEventListener('change', function() {
                    // Get the selected value
                    let selectedValue = this.value;

                    if(sellingPlansEl.closest('[data-js-widget]').classList.contains('active')){
                      // sellingPlansEl.closest('product-info').querySelector("input[name='selling_plan']").value = selectedValue

                      if(sellingPlansEl.closest('product-info').querySelectorAll(".sellingPlan").length){
                        sellingPlansEl.closest('product-info').querySelectorAll(".sellingPlan").forEach(function(sellingInput){
                          sellingInput.value = selectedValue
                        })
                      }
                    }
                });
              }

              // selling plan qty switch dropdown logic
              const qtySelects = document.querySelectorAll('[data-subscription-widget] [data-qty-select]');
            
              if(qtySelects.length) {
                // Loop through each select element
                qtySelects.forEach(qtySelect => {
                    // Add onchange event listener to each select element
                    qtySelect.addEventListener('change', function() {
                        // Get the selected quantity
                        const selectedQty = parseInt(this.value);

                        // Find the parent element with the attribute 'data-js-widget'
                        const parentElement = this.closest('[data-js-widget]');

                        if(parentElement.classList.contains('active')) {
                          // Get all origin blocks within the parent element
                          const originBlocks = parentElement.querySelectorAll('.origin');

                          // Loop through each origin block
                          originBlocks.forEach((block, index) => {
                              // Show or hide origin block based on selected quantity
                              if (index < selectedQty) {
                                  block.classList.remove('hidden');
                              } else {
                                  block.classList.add('hidden');
                              }
                          });

                          // now append items id in dom dynamically based on qty

                          if(product_form) {
                            const currentVal1 = parentElement.querySelector(".origin[data-var-index='0'] select").value;
                            const currentVal2 = parentElement.querySelector(".origin[data-var-index='1'] select").value;
                            const currentVal3 = parentElement.querySelector(".origin[data-var-index='2'] select").value;
                            const currentVal4 = parentElement.querySelector(".origin[data-var-index='3'] select").value;
                            let currentSellingPlan = parentElement.querySelector("select[name='selling_plan']");
                            let currentSellingPlanVal
                            if(currentSellingPlan) {
                              currentSellingPlanVal = currentSellingPlan.value
                            }

                            const masterIdEl = product_form.querySelector('.product-variant-id');

                            if(masterIdEl) {
                              masterIdEl.remove()
                            }

                            // price update in cta based on cta
                            const priceEl = product_form.querySelector('.product_dynamic-pricing');
                            const main_price = document.querySelector('.product__info-wrapper .price__regular .price-item')

                            if(priceEl && parentElement.classList.contains('active')) {
                              priceEl.innerHTML = formatMoney(parseInt(parentElement.getAttribute('data-price')) * selectedQty ,window.moneyFormat);
                            }

                            if(main_price) {
                              main_price.innerHTML = formatMoney(parseInt(parentElement.getAttribute('data-price')) * selectedQty ,window.moneyFormat)
                            }if(selectedQty == 2) {
                              if(parentElement.hasAttribute('data-option-onetime')) {
                                product_form.querySelector('.js-inputs-ids').innerHTML =
                                `<input type="hidden" name="[items][0][id]" value="${currentVal1}">
                                <input type="hidden" name="[items][1][id]" value="${currentVal2}">`
                              } else {
                                product_form.querySelector('.js-inputs-ids').innerHTML =
                                `<input type="hidden" name="[items][0][id]" value="${currentVal1}">
                                <input type="hidden" name="[items][1][id]" value="${currentVal2}">
                                <input type="hidden" name="[items][0][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                <input type="hidden" name="[items][1][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">`
                              }
                            } 
                            else if(selectedQty == 3) {
                              if(parentElement.hasAttribute('data-option-onetime')) {
                                product_form.querySelector('.js-inputs-ids').innerHTML =
                                `<input type="hidden" name="[items][0][id]" value="${currentVal1}">
                                <input type="hidden" name="[items][1][id]" value="${currentVal2}">
                                <input type="hidden" name="[items][2][id]" value="${currentVal3}">`
                              } else {
                                product_form.querySelector('.js-inputs-ids').innerHTML =
                                `<input type="hidden" name="[items][0][id]" value="${currentVal1}">
                                  <input type="hidden" name="[items][1][id]" value="${currentVal2}">
                                  <input type="hidden" name="[items][2][id]" value="${currentVal3}">
                                  <input type="hidden" name="[items][0][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                  <input type="hidden" name="[items][1][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                  <input type="hidden" name="[items][2][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                `
                              }
                            } else {
                              if(parentElement.hasAttribute('data-option-onetime')) { 
                                product_form.querySelector('.js-inputs-ids').innerHTML = 
                                `<input type="hidden" name="[items][0][id]" value="${currentVal1}">
                                <input type="hidden" name="[items][1][id]" value="${currentVal2}">
                                <input type="hidden" name="[items][2][id]" value="${currentVal3}">
                                <input type="hidden" name="[items][3][id]" value="${currentVal4}">`
                              } else {
                                product_form.querySelector('.js-inputs-ids').innerHTML = 
                                `<input type="hidden" name="[items][0][id]" value="${currentVal1}">
                                <input type="hidden" name="[items][1][id]" value="${currentVal2}">
                                <input type="hidden" name="[items][2][id]" value="${currentVal3}">
                                <input type="hidden" name="[items][3][id]" value="${currentVal4}">
                                <input type="hidden" name="[items][0][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                <input type="hidden" name="[items][1][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                <input type="hidden" name="[items][2][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                <input type="hidden" name="[items][3][selling_plan]" class="sellingPlan" value="${currentSellingPlanVal}">
                                `
                              }
                            }
                          }
                          
                        }
                    });
                });
              }

              const variantIdSelector = document.querySelectorAll('[data-subscription-widget] .origin');

              if(variantIdSelector.length) {
                variantIdSelector.forEach(function(origin){
                  origin.querySelector('select').addEventListener('change',function(e){

                    if(e.target.parentElement.getAttribute('data-var-index') == 0 
                    && e.target.closest('[data-js-widget]').querySelector('[data-qty-select]').value == 2) {
                    
                      product_form.querySelector('.js-inputs-ids').querySelector(`[name="[items][${e.target.parentElement.getAttribute('data-var-index')}][id]"]`).value = e.target.value
                      
                    } else {
                      product_form.querySelector('.js-inputs-ids').querySelector(`[name="[items][${e.target.parentElement.getAttribute('data-var-index')}][id]"]`).value = e.target.value
                    }

                  })
                })
              }
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
